var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"q-app"}},[_c('LoadingScreen'),_c('div',[_c('transition',{attrs:{"mode":"out-in","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }